<div class="revision-history">
  <div class="revision-history-header">
    <span class="revision-history-title">{{ 'EDITOR.REVISION_HISTORY.TITLE' | translate }}</span>
    <button type="button" class="revision-history-close" [attr.aria-label]="'EDITOR.REVISION_HISTORY.CLOSE' | translate" (click)="close.emit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="revision-history-filter">
    <mat-slide-toggle [checked]="filterSystemOnly" (change)="onToggleFilter($event.checked)">
      {{ 'EDITOR.REVISION_HISTORY.SYSTEM_FILTER' | translate }}
    </mat-slide-toggle>
  </div>

  <div class="revision-history-list">
    @if (loading) {
      <div class="revision-history-empty">{{ 'EDITOR.REVISION_HISTORY.LOADING' | translate }}</div>
    } @else if (hasNoResults) {
      <div class="revision-history-empty">
        {{ (filterSystemOnly ? 'EDITOR.REVISION_HISTORY.NO_SYSTEM_RESULTS' : 'EDITOR.REVISION_HISTORY.NO_RESULTS') | translate }}
      </div>
    } @else {
      @for (group of groups; track group.day) {
        <div class="revision-history-group">
          <div class="revision-history-group-label">{{ group.day }}</div>
          <div class="revision-history-cards">
            @for (revision of group.revisions; track revision.id) {
              <button
                type="button"
                class="revision-card"
                [class.is-selected]="revision.isSelected"
                [class.is-system]="revision.systemGenerated"
                (click)="select.emit(revision.id)"
              >
                <div class="revision-card-top">
                  <span class="revision-card-date">{{ revision.dateLabel }}</span>
                  @if (revision.isCurrent) {
                    <span class="revision-chip revision-chip-current">{{ 'EDITOR.REVISION_HISTORY.CURRENT' | translate }}</span>
                  }
                  @if (revision.systemGenerated) {
                    <span class="revision-chip revision-chip-ai">
                      <mat-icon>auto_awesome</mat-icon>
                      {{ 'EDITOR.REVISION_HISTORY.BRIEF_AI' | translate }}
                    </span>
                  }
                </div>
                <div class="revision-card-relative">{{ revision.relative }}</div>
                <div class="revision-card-author">
                  <app-avatar [input]="revision.authorName" size="small"></app-avatar>
                  <span class="revision-card-author-name">{{ revision.authorName }}</span>
                  @if (revision.otherAuthorCount > 0) {
                    <span class="revision-card-author-others">{{
                      (revision.otherAuthorCount === 1 ? 'EDITOR.REVISION_HISTORY.OTHER_AUTHOR' : 'EDITOR.REVISION_HISTORY.OTHER_AUTHORS')
                        | translate: { count: revision.otherAuthorCount }
                    }}</span>
                  }
                  @if (revision.minutesVerboseness !== null) {
                    <span
                      class="revision-chip revision-chip-detail"
                      role="img"
                      [title]="'MINUTES_STYLING.' + revision.minutesVerboseness | translate"
                      [attr.aria-label]="'MINUTES_STYLING.' + revision.minutesVerboseness | translate"
                    >
                      <mat-icon fontSet="material-symbols-outlined">{{ revision.verbosenessIcon }}</mat-icon>
                    </span>
                  }
                </div>
              </button>
            }
          </div>
        </div>
      }
    }
  </div>
</div>
